import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';
import type { AgreementSummary } from 'types';

export function get(appID: string | number): Promise<AxiosResponse<AgreementSummary>> {
    return client.get<AgreementSummary>(`/agreement/${appID}`);
}

/** Unsigned PDF render; the backend answers 409 once signed (use `summary.pdf_url` instead). */
export function getPdf(appID: string | number): Promise<AxiosResponse<Blob>> {
    return client.get<Blob>(`/agreement/${appID}/pdf`, { responseType: 'blob' });
}

export function post(
    id: string | number,
    payload: FormData,
    customConfig?: AxiosRequestConfig<FormData>
): Promise<AxiosResponse<unknown>> {
    return client.post<unknown>(`/agreement/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
        ...customConfig,
    });
}

export function deleteAgreement(agreementId: string | number): Promise<AxiosResponse<unknown>> {
    return client.delete<unknown>(`/agreements/${agreementId}`);
}

export function getAgreementTableData(userID: string) {
    return client.get(`/users/${userID}/agreements`, {
        headers: { 'Content-Type': 'binary/octet-stream' },
    });
}
